import React from "react";

const Title = ({ text, myClass }) => {
  return (
    <h2
      className={`${myClass} font-bold !leading-[120%] text-[58px] text-[#010101] max-xl:text-5xl max-lg:text-4xl max-md:text-[32px]`}
    >
      {text}
    </h2>
  );
};

export default Title;
